module.exports = __webpack_public_path__ + "public/img/po.e8d7c320.png";